module.exports = __webpack_public_path__ + "img/everpay-white.26a16447.png";